// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EvaluationPage-module__evaluatorPage {
  flex: 1;
  background-color: #f7f7fc;
  padding-bottom: 84px;
}

.EvaluationPage-module__evaluatorHeader {
  display: flex;
  align-items: center;
  padding: 0px 20px;
  border-bottom: 1px solid #ddd;
  height: 79px;
}

.EvaluationPage-module__backBtn {
  background: none;
  border: none;
  cursor: pointer;
  margin-right: 20px;
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 500;
  font-style: Medium;
  font-size: 16px;
  line-height: 130%;
  color: #14142b;
  width: auto;
}

.EvaluationPage-module__testInfo {
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: flex-end;
  align-items: center;
  margin-left: 20px;
  gap: 8px;
  border-left: 1px solid #ddd;
  padding-left: 20px;
}

.EvaluationPage-module__testInfo h2 {
  font-weight: 600;
  font-size: 20px;
  color: #14142b;
  margin: 0;
  padding: 0;
}

.EvaluationPage-module__testInfo p {
  font-weight: 500;
  font-size: 18px;
  color: #263643;
  margin: 0;
}

.EvaluationPage-module__mainContainer {
  padding: 0px 38px;
}

.EvaluationPage-module__evaluatorMainContent {
  display: flex;
  padding: 10px 0px;
  gap: 10px;
}

.EvaluationPage-module__reportSummaryWrapper {
  width: 100%;
}

.EvaluationPage-module__leftSidePanel {
  width: 65%;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.EvaluationPage-module__leftSidePanel p {
  font-weight: 600;
  font-size: 20px;
  line-height: 100%;
  letter-spacing: 0%;
}

/* Tab Bar Container */
.EvaluationPage-module__tabBar {
  display: flex;
  justify-content: center;
  width: 100%;
  height: auto;
  border-radius: 12px;
  padding-top: 8px;
  gap: 16px;
  background: #e5e5ea99;
  margin-bottom: 10px;
}

/* Individual Tab Button */
.EvaluationPage-module__tab {
  outline: none;
  appearance: none;
  width: auto;
  position: relative;
  width: auto;
  min-width: 140px;
  height: 48px;
  background: transparent;
  border: none;
  border-radius: 12px 12px 0 0;
  color: #4e4b66;
  font-weight: 600;
  font-size: 16px;
  cursor: pointer;
  padding: 0 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: visible;
  transition: color 0.2s ease;
}

.EvaluationPage-module__tab:hover {
  color: #3c8dcb;
}

.EvaluationPage-module__tabLabel {
  position: relative;
  z-index: 2;
  pointer-events: none;
}

.EvaluationPage-module__activeTabIndicator {
  position: absolute;
  inset: 0;
  background: #f7f7fc;
  border-radius: 12px 12px 0 0;
  z-index: 1;
}

.EvaluationPage-module__activeTabIndicator::before {
  content: "";
  position: absolute;
  bottom: 0;
  left: -12px;
  width: 12px;
  height: 12px;
  background: radial-gradient(
    circle at top left,
    transparent 12px,
    #ffffff 12.5px
  );
}

.EvaluationPage-module__activeTabIndicator::after {
  content: "";
  position: absolute;
  bottom: 0;
  right: -12px;
  width: 12px;
  height: 12px;
  background: radial-gradient(
    circle at top right,
    transparent 12px,
    #ffffff 12.5px
  );
}

.EvaluationPage-module__slideContainer {
  overflow: hidden;
}

.EvaluationPage-module__questionSection {
  overflow: hidden;
}

.EvaluationPage-module__rightSidePanel {
  width: 35%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 92px;
}

.EvaluationPage-module__questionIndicator {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px !important;
  height: 48px !important;
  min-width: 48px !important;
  opacity: 1;
  position: relative;
  border-radius: 5px;
  padding: 6px 11px;
  gap: 10px;
  border: 1px solid #b8c2cc;
  background-color: #ffffff;
  cursor: pointer;
  font-size: 18px;
  font-weight: 600;
  line-height: 100%;
  color: #6e7191;
}
.EvaluationPage-module__questionIndicator.EvaluationPage-module__answeredAndSelected {
  border: 2px solid #3c8dcb;
  background-color: #3c8dcb;
  color: #fcfcfc;
}
.EvaluationPage-module__questionIndicator.EvaluationPage-module__answered {
  border: 2px solid #3c8dcb;
  background-color: #3c8dcb;
  color: #fcfcfc;
}
.EvaluationPage-module__questionIndicator.EvaluationPage-module__selected {
  border: 2px solid #3c8dcb;
  color: #3c8dcb;
}
.EvaluationPage-module__questionIndicator img {
  position: absolute;
  width: 11.7px;
  height: 8.5px;
  opacity: 1;
  top: 3.75px;
  right: 1.66px;
}

.EvaluationPage-module__questionsNavigationWrapper {
  display: flex;
  align-items: center;
  width: 100%;
  position: relative;
  padding: 10px 0px;
}

.EvaluationPage-module__questionsNavigationBar {
  display: flex;
  gap: 14px;
  height: 48px;
  overflow-x: auto;
  scroll-behavior: smooth;
  scrollbar-width: none;
}

.EvaluationPage-module__questionsNavigationBar::-webkit-scrollbar {
  display: none;
}

.EvaluationPage-module__chevronIcons {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  background: transparent;
  cursor: pointer;
  flex-shrink: 0;
}
.EvaluationPage-module__chevronIcons img {
  width: 22px;
  height: 22px;
}

.EvaluationPage-module__reportErrorBtn {
  background: #00354E;
  color: #FCFCFC;
  width: auto;
  height: 44px;
  border-radius: 40px;
  padding: 0px 24px;
  margin-right: 38px;
  border: none;
  font-weight: 600;
  font-size: 16px;
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/pages/evaluationpage/EvaluationPage.module.css"],"names":[],"mappings":"AAAA;EACE,OAAO;EACP,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,QAAQ;EACR,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,SAAS;AACX;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,SAAS;EACT,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,uBAAuB;EACvB,YAAY;EACZ,4BAA4B;EAC5B,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,mBAAmB;EACnB,4BAA4B;EAC5B,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ;;;;GAIC;AACH;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,WAAW;EACX,YAAY;EACZ;;;;GAIC;AACH;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,uBAAuB;EACvB,0BAA0B;EAC1B,UAAU;EACV,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,SAAS;EACT,yBAAyB;EACzB,yBAAyB;EACzB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,UAAU;EACV,WAAW;EACX,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,eAAe;AACjB","sourcesContent":[".evaluatorPage {\n  flex: 1;\n  background-color: #f7f7fc;\n  padding-bottom: 84px;\n}\n\n.evaluatorHeader {\n  display: flex;\n  align-items: center;\n  padding: 0px 20px;\n  border-bottom: 1px solid #ddd;\n  height: 79px;\n}\n\n.backBtn {\n  background: none;\n  border: none;\n  cursor: pointer;\n  margin-right: 20px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-weight: 500;\n  font-style: Medium;\n  font-size: 16px;\n  line-height: 130%;\n  color: #14142b;\n  width: auto;\n}\n\n.testInfo {\n  display: flex;\n  flex-direction: row;\n  width: 100%;\n  justify-content: flex-end;\n  align-items: center;\n  margin-left: 20px;\n  gap: 8px;\n  border-left: 1px solid #ddd;\n  padding-left: 20px;\n}\n\n.testInfo h2 {\n  font-weight: 600;\n  font-size: 20px;\n  color: #14142b;\n  margin: 0;\n  padding: 0;\n}\n\n.testInfo p {\n  font-weight: 500;\n  font-size: 18px;\n  color: #263643;\n  margin: 0;\n}\n\n.mainContainer {\n  padding: 0px 38px;\n}\n\n.evaluatorMainContent {\n  display: flex;\n  padding: 10px 0px;\n  gap: 10px;\n}\n\n.reportSummaryWrapper {\n  width: 100%;\n}\n\n.leftSidePanel {\n  width: 65%;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.leftSidePanel p {\n  font-weight: 600;\n  font-size: 20px;\n  line-height: 100%;\n  letter-spacing: 0%;\n}\n\n/* Tab Bar Container */\n.tabBar {\n  display: flex;\n  justify-content: center;\n  width: 100%;\n  height: auto;\n  border-radius: 12px;\n  padding-top: 8px;\n  gap: 16px;\n  background: #e5e5ea99;\n  margin-bottom: 10px;\n}\n\n/* Individual Tab Button */\n.tab {\n  outline: none;\n  appearance: none;\n  width: auto;\n  position: relative;\n  width: auto;\n  min-width: 140px;\n  height: 48px;\n  background: transparent;\n  border: none;\n  border-radius: 12px 12px 0 0;\n  color: #4e4b66;\n  font-weight: 600;\n  font-size: 16px;\n  cursor: pointer;\n  padding: 0 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: visible;\n  transition: color 0.2s ease;\n}\n\n.tab:hover {\n  color: #3c8dcb;\n}\n\n.tabLabel {\n  position: relative;\n  z-index: 2;\n  pointer-events: none;\n}\n\n.activeTabIndicator {\n  position: absolute;\n  inset: 0;\n  background: #f7f7fc;\n  border-radius: 12px 12px 0 0;\n  z-index: 1;\n}\n\n.activeTabIndicator::before {\n  content: \"\";\n  position: absolute;\n  bottom: 0;\n  left: -12px;\n  width: 12px;\n  height: 12px;\n  background: radial-gradient(\n    circle at top left,\n    transparent 12px,\n    #ffffff 12.5px\n  );\n}\n\n.activeTabIndicator::after {\n  content: \"\";\n  position: absolute;\n  bottom: 0;\n  right: -12px;\n  width: 12px;\n  height: 12px;\n  background: radial-gradient(\n    circle at top right,\n    transparent 12px,\n    #ffffff 12.5px\n  );\n}\n\n.slideContainer {\n  overflow: hidden;\n}\n\n.questionSection {\n  overflow: hidden;\n}\n\n.rightSidePanel {\n  width: 35%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin-top: 92px;\n}\n\n.questionIndicator {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 48px !important;\n  height: 48px !important;\n  min-width: 48px !important;\n  opacity: 1;\n  position: relative;\n  border-radius: 5px;\n  padding: 6px 11px;\n  gap: 10px;\n  border: 1px solid #b8c2cc;\n  background-color: #ffffff;\n  cursor: pointer;\n  font-size: 18px;\n  font-weight: 600;\n  line-height: 100%;\n  color: #6e7191;\n}\n.questionIndicator.answeredAndSelected {\n  border: 2px solid #3c8dcb;\n  background-color: #3c8dcb;\n  color: #fcfcfc;\n}\n.questionIndicator.answered {\n  border: 2px solid #3c8dcb;\n  background-color: #3c8dcb;\n  color: #fcfcfc;\n}\n.questionIndicator.selected {\n  border: 2px solid #3c8dcb;\n  color: #3c8dcb;\n}\n.questionIndicator img {\n  position: absolute;\n  width: 11.7px;\n  height: 8.5px;\n  opacity: 1;\n  top: 3.75px;\n  right: 1.66px;\n}\n\n.questionsNavigationWrapper {\n  display: flex;\n  align-items: center;\n  width: 100%;\n  position: relative;\n  padding: 10px 0px;\n}\n\n.questionsNavigationBar {\n  display: flex;\n  gap: 14px;\n  height: 48px;\n  overflow-x: auto;\n  scroll-behavior: smooth;\n  scrollbar-width: none;\n}\n\n.questionsNavigationBar::-webkit-scrollbar {\n  display: none;\n}\n\n.chevronIcons {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 48px;\n  height: 48px;\n  background: transparent;\n  cursor: pointer;\n  flex-shrink: 0;\n}\n.chevronIcons img {\n  width: 22px;\n  height: 22px;\n}\n\n.reportErrorBtn {\n  background: #00354E;\n  color: #FCFCFC;\n  width: auto;\n  height: 44px;\n  border-radius: 40px;\n  padding: 0px 24px;\n  margin-right: 38px;\n  border: none;\n  font-weight: 600;\n  font-size: 16px;\n  cursor: pointer;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"evaluatorPage": `EvaluationPage-module__evaluatorPage`,
	"evaluatorHeader": `EvaluationPage-module__evaluatorHeader`,
	"backBtn": `EvaluationPage-module__backBtn`,
	"testInfo": `EvaluationPage-module__testInfo`,
	"mainContainer": `EvaluationPage-module__mainContainer`,
	"evaluatorMainContent": `EvaluationPage-module__evaluatorMainContent`,
	"reportSummaryWrapper": `EvaluationPage-module__reportSummaryWrapper`,
	"leftSidePanel": `EvaluationPage-module__leftSidePanel`,
	"tabBar": `EvaluationPage-module__tabBar`,
	"tab": `EvaluationPage-module__tab`,
	"tabLabel": `EvaluationPage-module__tabLabel`,
	"activeTabIndicator": `EvaluationPage-module__activeTabIndicator`,
	"slideContainer": `EvaluationPage-module__slideContainer`,
	"questionSection": `EvaluationPage-module__questionSection`,
	"rightSidePanel": `EvaluationPage-module__rightSidePanel`,
	"questionIndicator": `EvaluationPage-module__questionIndicator`,
	"answeredAndSelected": `EvaluationPage-module__answeredAndSelected`,
	"answered": `EvaluationPage-module__answered`,
	"selected": `EvaluationPage-module__selected`,
	"questionsNavigationWrapper": `EvaluationPage-module__questionsNavigationWrapper`,
	"questionsNavigationBar": `EvaluationPage-module__questionsNavigationBar`,
	"chevronIcons": `EvaluationPage-module__chevronIcons`,
	"reportErrorBtn": `EvaluationPage-module__reportErrorBtn`
};
export default ___CSS_LOADER_EXPORT___;
